import axios from 'axios'

const baseHost = window.env && window.env.baseHost

export const getTerms = (term) =>
  axios.get(
    `/quick_search?term=${term}`,
    {
      baseURL: baseHost,
      withCredentials: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
      }
    }
  )
